module.exports = __webpack_public_path__ + "static/media/logo_kulturwerk.0301d78a.png";